import { Typography } from "@mui/material";
import React, { ClassAttributes, ElementType, HTMLAttributes } from "react";
import { ExtraProps } from "react-markdown";

export const UlRender: React.ElementType<
  React.ClassAttributes<HTMLUListElement> &
    React.HTMLAttributes<HTMLUListElement> &
    ExtraProps
> = ({ children }) => (
  <ul style={{ fontFamily: "ABBvoice" }} >
    {children}
  </ul>
);

export const PRender: ElementType<
  ClassAttributes<HTMLParagraphElement> &
    HTMLAttributes<HTMLParagraphElement> &
    ExtraProps
> = ({ children }) => (
  <Typography
    variant="bodyMediumWeightRegular"
    component="p"
    sx={{
      margin: "16px 0",
      fontSize: "16px",
    }}
  >
    {children}
  </Typography>
);

export const EmRender: ElementType<
  ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement> & ExtraProps
> = ({ children }) => (
  <Typography
    variant="bodyMediumWeightRegular"
    component="em"
    sx={(theme) => ({
      margin: "16px 0",
      fontSize: "16px",
      color: theme.palette.grey[600],
    })}
  >
    {children}
  </Typography>
);
